module.exports = __webpack_public_path__ + "img/t2-c17.6b8e2bd0.png";